export default __webpack_public_path__ + "static/media/Group1268-tata-neu.fd94d806.png";